<template>
  <div class="page">
    <div class="content">
      <div class="title">如何编辑题目、修改答题设置？</div>
      <p class="way-title first">
        <img
          src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220620/bd3fabb40ddc8db2e45eb1f6bddb48cc.svg"
          alt=""
        />用手机管理
      </p>
      <div class="desc">
        {{
          !showType
            ? "点击下方按钮，进入小程序管理答题"
            : "使用微信扫描下，进入小程序管理答题"
        }}
      </div>
      <div v-if="!showType && settingUrl" class="mobile-edit">
        <button class="copy-btn" @click="toWx">前往管理</button>
        <WxLink v-if="isWeixin" :wxPath="wxPath + qid" />
      </div>
      <img v-else-if="showType && settingSrc" :src="settingSrc" alt="" />
      <template v-if="isMobile">
        <p class="loginTip" @click="changeLoginType">
          {{ showType ? "使用一键打开" : "点击没反应？点我试试扫码打开" }}
        </p>
      </template>
      <div class="first">
        <p class="way-title">
          <img
            src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220620/8d095cda4a2b673c1fc1290d1d96129c.svg"
            alt=""
          />用电脑管理
        </p>
        <p v-if="isMobile || !isInApp" class="copyTip">
          复制网址在浏览器打开官网进行修改
        </p>
        <p @click="!isMobile && isInApp ? goWeb() : ''">
          {{ isInApp && !isMobile ? "点击进入立吉答题官网：" : "官网网址："
          }}<span :class="!isMobile && isInApp ? 'blue' : 'themeColor'"
            >xiaoxiaodati.com</span
          >
        </p>
        <button
          class="copy-btn"
          v-clipboard:copy="copyText"
          v-clipboard:success="firstCopySuccess"
          v-clipboard:error="firstCopyError"
        >
          一键复制
        </button>
      </div>

      <!-- <div class="finish">
        <button class="btn" @click="finishCreate">我知道啦</button>
      </div> -->
    </div>
  </div>
</template>
<script>
import { Toast } from "vant";
import { getDetailWxCode, isMobile, goWebWay, isWeixin } from "@/utils/common";
import WxLink from "@/components/wxLink.vue";

export default {
  props: {
    settingUrl: {
      type: String,
      default: ""
    },
    settingSrc: {
      type: String,
      default:
        "https://cdn-xcx-qunsou.weiyoubot.cn/material/20211013/986befc70730defd7e2e5bd2272a393b.png"
    },
    showType: {
      type: Number,
      default: 0
    },
    qid: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      copyText: "https://xiaoxiaodati.com/",
      isMobile: isMobile(),
      isWeixin: isWeixin(),
      isInApp: wemeet.app.isTMWebview(),
      wxPath: "/pages/detail/detail?qid="
    };
  },
  components: { WxLink },
  methods: {
    goWeb() {
      goWebWay();
    },
    async changeLoginType() {
      let showType = this.showType;
      if (!showType) {
        // 切换为扫码登录
        if (!this.settingSrc) {
          let settingSrc = await getDetailWxCode(this.qid);
          if (settingSrc) {
            this.$emit("changeSetting", {
              type: "settingSrc",
              value: settingSrc
            });
          }
        }
        this.$emit("changeSetting", {
          type: "showType",
          value: 1
        });
      } else {
        this.$emit("changeSetting", {
          type: "showType",
          value: 0
        });
      }
    },
    firstCopySuccess() {
      Toast("复制成功");
    },
    firstCopyError() {
      Toast("复制失败");
    },
    toWx() {
      window.location.href = this.settingUrl;
    }
  }
};
</script>
<style lang="scss" scoped>
// @function $px) {
//   @return $px / 75 + rem;
// }
.page {
  width: 100%;
  padding: 40px 15px 15px;
  box-sizing: border-box;
  color: #262626;
  font-size: 14px;
  .content {
    background: #fff;
    border-radius: 4px;
    .title {
      font-weight: 700;
      font-size: 17px;
      line-height: 25px;
      text-align: center;
    }
    .desc {
      font-size: 14px;
      line-height: 21px;
    }
    .mt20 {
      margin-top: 10px;
      font-size: 14px;
    }
    .finish {
      margin-top: 15px;
    }
    img {
      width: 175px;
      height: 175px;
      display: block;
      margin: 0 auto;
      margin-top: 15px;
    }
  }
  .first {
    line-height: 27px;
    margin: 20px 0 5px;
  }
  .way-title {
    font-weight: 700;
    font-size: 15px;
    display: flex;
    align-items: center;
    img {
      width: 18px;
      height: 18px;
      display: inline-block;
      margin: 0 5px 0 0;
    }
  }
  .blue {
    color: #1890ff;
    cursor: pointer;
  }
  .tips {
    text-align: center;
    margin-top: 15px;
    color: #999999;
  }
  .copy-btn {
    text-align: center;
    background: #1890ff;
    color: #fff;
    font-size: 14px;
    border-radius: 4px;
    line-height: 21px;
    padding: 5px 15px;
    margin-top: 5px;
    cursor: pointer;
  }
  .login-img-modal {
    text-align: center;
    font-size: 11px;
    padding: 15px;
    p {
      margin-top: 15px;
      color: #999999;
      line-height: 15px;
    }
  }
  .login-img {
    width: 225px;
    height: 225px;
  }
  .copyTip {
    margin-top: 5px;
    font-size: 14px;
  }
  .loginTip {
    font-size: 14px;
    line-height: 21px;
    color: #999999;
    margin-top: 5px;
    cursor: pointer;
  }
}
.mobile-edit {
  position: relative;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/detail/setting.vue